// extracted by mini-css-extract-plugin
export default {"keyboard":"index_keyboard__onbyd","left":"index_left__4YYsD"};